import { render, staticRenderFns } from "./CommissionSettingsModal.vue?vue&type=template&id=438431d6&scoped=true&"
import script from "./CommissionSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CommissionSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./CommissionSettingsModal.vue?vue&type=style&index=0&id=438431d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438431d6",
  null
  
)

export default component.exports